const rows = [
  { digits: [2, 7, 4, 9], exact: 2, misplaced: 0, muted: true },
  { digits: [6, 1, 8, 3], exact: 0, misplaced: 2 },
  { digits: [5, 3, 6, 0], exact: 1, misplaced: 3 },
  { digits: [5, 0, 3, 6], exact: 4, misplaced: 0, solved: true },
];

export function CodeMotif() {
  return (
    <div className="code-motif" aria-hidden="true">
      {rows.map((row, rowIndex) => (
        <div
          className={`code-row${row.muted ? " code-row--muted" : ""}${row.solved ? " code-row--solved" : ""}`}
          key={rowIndex}
        >
          <div className="code-row__digits">
            {row.digits.map((digit, digitIndex) => <span key={digitIndex}>{digit}</span>)}
          </div>
          <div className="feedback">
            <span><i className="feedback__dot" />{row.exact}</span>
            <span><i className="feedback__ring" />{row.misplaced}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
